import React from "react";

import Heading from "components/heading";
import { getFormattedValue } from "components/helpers";
import Image from "next/image";
import FigureImage from "public/enerflo-light.png";

import HeroSection from "../../hero-section";
import { fallbackData, SiteData } from "../constants";
import styles from "./index.module.css";

const title = "Enerflo’s Origin";

type HistoryProps = { data: SiteData };
const History = ({ data }: HistoryProps) => (
  <div className="bg-navy-dark overflow-hidden">
    <HeroSection title={title} className="flex-col-reverse relative md:flex-row">
      <HeroSection.Content className="md:w-2/3 py-8 relative z-[1]">
        <HeroSection.Header className="text-white md:items-start">
          <Heading tag="h2">{title}</Heading>
        </HeroSection.Header>
        <div className="text-base text-gray-100 space-y-4">
          <p>
            Once upon a time in 2019, a solar guy and a tech guy came together to simplify the solar sales process
            through technology. In the early days, Pat would code at night and Spencer would knock doors the next day to
            test the technology on real customers. With Spencer’s extensive sales and solar background and Pat’s
            experience of building software companies, things quickly progressed.
          </p>
          <p>
            Now, a few years later, Enerflo has grown it’s professional team and customer base fast, already processing
            ${getFormattedValue((data || fallbackData).revenueToDate).toUpperCase()} in solar transactions to date.
            Enerflo’s rapid growth is a testament to the Founders’ clear vision for creating a truly open platform that
            can intelligently integrate all of the great tools and applications that dealers and installers are already
            using.
          </p>
          <p>
            Enerflo’s on a mission: Make solar affordable for, and available to, every human on the planet. It’s a
            simple but lofty goal that drives Enerflo’s employees every day. We invite you to join us and grow with
            Enerflo.
          </p>
        </div>
      </HeroSection.Content>

      <figure className="flex-grow p-6 md:pl-6 w-full xs:w-4/5 sm:w-3/5 md:w-1/3 relative z-[1]">
        <Image src={FigureImage} alt="Enerflo Logo" layout="responsive" quality={100} placeholder="blur" />
      </figure>
      <div className={styles.accentOrb} />
    </HeroSection>
  </div>
);

export default History;
